import cn from 'classnames';
import styles from './LinkPrimary.module.scss';
import Link from 'next/link';
import { MouseEvent } from 'react';

type LinkPrimaryProps = {
  className?: string;
  href: string;
  onClick?: () => void;
  text: string;
};

export function LinkPrimary({
  className,
  href,
  onClick,
  text,
}: LinkPrimaryProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    if (onClick) {
      onClick();
    }
  };

  return (
    <Link className={wrapperClassName} href={href} onClick={handleClick}>
      {text}
    </Link>
  );
}
